module.exports = __webpack_public_path__ + "media/images/segment_engineer_static-8502aa202fb8a5021ef08d18dc9063f9.svg";